import { createSlice } from '@reduxjs/toolkit';
import { merge, reduce } from 'lodash';

import { ENTITY_TYPES } from 'src/constants';

const initialState = reduce(
  ENTITY_TYPES,
  (result) => {
    result = merge(
      {
        nomenclature: null,
        loading: false,
      },
    );
    return result;
  },
  {},
);

const slice = createSlice({
  name: 'nomenclature',
  initialState,
  reducers: {
    createNomenclatureStart(state, { payload }) { },
    createNomenclatureSuccess(state, { payload }) { },
    createNomenclatureFailure(state, { payload }) { },
    getNomenclatureStart(state, { payload }) {
      state.loading = true;
    },
    getNomenclatureSuccess(state, { payload }) {
      const { response } = payload;
      state.nomenclature = response;
      state.loading = false;
    },
    getNomenclatureFailure(state, { payload }) { },
    editNomenclatureStart(state, { payload }) {
      state.loading = true;
    },
    editNomenclatureSuccess(state, { payload }) {
      const { response } = payload;
      state.loading = false;
      state.nomenclature = response;
    },
    editNomenclatureFailure(state, { payload }) { },
  },
});

export const { actions } = slice;

export default slice.reducer;
